export const SET_LOCATION      = "LOCATION/SET_LOCATION"
export const SET_STREET_NAME   = "LOCATION/SET_STREET_NAME"
export const SET_STREET_NUMBER = "LOCATION/SET_STREET_NUMBER"
export const SET_NEIGHBORHOOD  = "LOCATION/SET_NEIGHBORHOOD"
export const SET_POSTAL_CODE   = "LOCATION/SET_POSTAL_CODE"
export const SET_CITY          = "LOCATION/SET_CITY"
export const SET_UF            = "LOCATION/SET_UF"
export const SET_COUNTRY       = "LOCATION/SET_COUNTRY"
export const SET_LATITUDE      = "LOCATION/SET_LATITUDE"
export const SET_LONGITUDE     = "LOCATION/SET_LONGITUDE"
export const SET_USER_ID     = "LOCATION/SET_USER_ID"